import { API, graphqlOperation } from "aws-amplify";
import { axiosInstanceForLambda } from "../library/Axios";

function extractErrorMessage(inputString) {
  let match = inputString?.match(/Error: (.*?);/);
  if (!match) {
    match = inputString?.match(/ERROR: (.*?);/);
  }
  return match ? match[1] : null; // Return the matched group or null if no match
}

export const baseQuery = async ({ body, variables }) => {
  try {
    const response = await API.graphql(graphqlOperation(body, variables));
    if (response.errors?.length) {
      const error = response.errors[0];
      return {
        error: {
          message: extractErrorMessage(error.message) || error.message || "An error occurred",
          status: 400, // Assuming 400 Bad Request for this case
          originalResponse: response,
        },
      };
    }
    let value = { data: Object.values(response.data)?.[0] };
    console.log(value)
    return value
  } catch (err) {
    console.log(err)
    
    return {
      error: {
        message: extractErrorMessage(err?.errors?.[0]?.message) || "A network error occurred",
        status: 500,
        originalResponse: err,
      },
    };
  }
};


export const baseQueryv2 = async ({ body, variables }) => {
  try {
    const response = await API.graphql(graphqlOperation(body, variables));
    if (response.errors?.length) {
      const error = response.errors[0];
      return {
        error: {
          message: extractErrorMessage(error.message) || error.message || "An error occurred",
          status: 400, // Assuming 400 Bad Request for this case
          originalResponse: response,
        },
      };
    }
    let value = { data: Object.values(response.data)?.[0] };
    console.log(value)
    return value
  } catch (err) {
    console.log(err)
    
    throw new Error(extractErrorMessage(err?.errors?.[0]?.message)?.split(",")?.[0]?.trim() || "A network error occurred");
    return {
      error: {
        message: extractErrorMessage(err?.errors?.[0]?.message) || "A network error occurred",
        messageTrimmed: extractErrorMessage(err?.errors?.[0]?.message).split(",")[0].trim(),
        status: 500,
        originalResponse: err,
      },
    };
  }
};


export const axiosBaseQuery = async ({ url, method, data, params }) => {
  try {
    const result = await axiosInstanceForLambda({
      url,
      method,
      data,
      params,
    });
    return { data: result.data };
  } catch (error) {
    return {
      error: {
        status: error.response?.status || 500, // Handle cases where response might be undefined
        data: error.response?.data || error.message || "Unknown error occurred",
      },
    };
  }
};